import { capitalizeIfLower } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { formsClient } from '../../../../utils/apollo/api'
import { useForms } from '../_load/FormsLoader'
import { useNavigation } from '../../../../utils/contexts/NavigationContext'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import { useRowsActions } from './_actions/rowsActions'
import AccessTag from '../../../../components/presentation/AccessTag'
import ChecklistSelect from '../../../../containers/checklists/select/ChecklistSelect'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import EditableForm from '../../../../containers/forms/EditableForm'
import Link from '../../../../components/actions/Link'
import ListCounter from '../../../../components/helpers/ListCounter'
import Text from '../../../../packages/kiti/components/presentation/Text'

const FormsTable = () => {
  const { t } = useTranslation('listForms')
  const data = useForms()
  const navigate = useNavigation()

  const columns = [
    {
      label: t('name'),
      headerSideContent: (
        <>
          <ListCounter client={formsClient} entity="forms" filterName="FormFilter" />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      flex: 4,
      render: (value, record) => (
        <EditableForm record={record} field="name">
          <Link onClick={() => navigate(`/forms/${record.id}/form-replies`)} block>
            <Text color="dark1" bold>
              {value}
            </Text>
          </Link>
        </EditableForm>
      ),
      sortIndex: 'NAME'
    },

    {
      label: t('checklist'),
      dataIndex: ['checklist', 'name'],
      render: (value, record) => (
        <EditableForm record={record} field="checklist" Input={ChecklistSelect}>
          <Text>{capitalizeIfLower(value)}</Text>
        </EditableForm>
      ),
      sortIndex: 'CHECKLIST_NAME',
      flex: 3
    },

    {
      label: t('replies'),
      dataIndex: 'repliesCount',
      sortIndex: false,
      flex: 2
    },

    {
      label: t('access'),
      dataIndex: 'access',
      sortIndex: 'ACCESS',
      flex: 2,
      render: (value, record) => <AccessTag value={value} />
    },

    {
      label: t('actions'),
      flex: 1,
      render: useRowActionsColumn(useRowsActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default FormsTable
